<template>
  <span v-if="bookmark.isFile" class="of-hidden d-flex align-center">
    <component :is="bookmark.isVideo ? PhVideoCamera : PhImage" v-if="!noIcon" weight="fill" class="flex-grow-0 text-body-1 mr-2" />
    <span class="d-block text-truncate">{{ $t(bookmark.isVideo ? 'common.video' : 'common.image') }}</span>
  </span>
  <span v-else class="of-hidden d-flex align-center">
    <BrandImage
      v-if="!noIcon"
      :src="favicon" contain
      class="bookmark-source__favicon flex-grow-0 text-body-1 mr-2 rounded"
      :class="bookmark.hasFavicon ? '' : bookmark.colorClasses"
    />
    <span class="d-block text-truncate">{{ domain }}</span>
  </span>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { PhImage, PhVideoCamera } from '@phosphor-icons/vue'

const props = defineProps({
  noIcon: Boolean,
  bookmark: {
    type: Object,
    default: null,
  },
})

const domain = computed(() => {
  // The backend now provides the correct domain with compound TLDs handled
  // No need for additional processing
  return props.bookmark.domain
})

const favicon = computed(() => {
  return props.bookmark.faviconUrl
})
</script>

<style lang="scss" scoped>
// A square as tall as the line's type, never squeezed by a long domain.
.bookmark-source__favicon {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
}
</style>
